export const scheduledSessions = [
  {
    id: 1,
    status: "today" as const,
    month: "APR",
    day: "11",
    dateLabel: "April 11, 2026",
    time: "10:00 AM",
    duration: "60 min",
    topic: "Portfolio Review & Case Study",
    mentorName: "Sarah Chen",
    mentorRole: "Senior UX Designer",
    mentorCompany: "Figma",
    mentorPhoto: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20asian%20woman%20smiling%20warmly%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20confident%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor1&orientation=squarish",
    agenda: [
      "Intro & goal alignment (5 min)",
      "Review portfolio & current projects (20 min)",
      "Identify skill gaps for UX transition (15 min)",
      "Build a 30-day action plan (15 min)",
      "Q&A and next steps (5 min)",
    ],
    prepNotes: [
      "Share your Figma portfolio link before the session",
      "Prepare 2-3 questions about case study structure",
      "Review NNGroup article on UX case studies",
    ],
  },
  {
    id: 2,
    status: "upcoming" as const,
    month: "APR",
    day: "18",
    dateLabel: "April 18, 2026",
    time: "7:00 PM",
    duration: "45 min",
    topic: "Figma Deep Dive — Auto Layout",
    mentorName: "Sarah Chen",
    mentorRole: "Senior UX Designer",
    mentorCompany: "Figma",
    mentorPhoto: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20asian%20woman%20smiling%20warmly%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20confident%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor1&orientation=squarish",
    agenda: [
      "Quick check-in on last session tasks (5 min)",
      "Live Figma walkthrough — Auto Layout (20 min)",
      "Component variants and design tokens (15 min)",
      "Homework assignment (5 min)",
    ],
    prepNotes: [
      "Complete the 2 Figma tutorials assigned last session",
      "Bring a design you want to rebuild with Auto Layout",
      "Watch Figma's official Auto Layout video (15 min)",
    ],
  },
  {
    id: 3,
    status: "upcoming" as const,
    month: "APR",
    day: "25",
    dateLabel: "April 25, 2026",
    time: "12:00 PM",
    duration: "60 min",
    topic: "Networking Strategy & LinkedIn",
    mentorName: "Marcus Williams",
    mentorRole: "Staff Engineer",
    mentorCompany: "Stripe",
    mentorPhoto: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20black%20man%20smiling%20confidently%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20approachable%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor2&orientation=squarish",
    agenda: [
      "Review your LinkedIn profile together (15 min)",
      "Craft your outreach message template (15 min)",
      "Identify 10 target designers to connect with (20 min)",
      "Mock cold outreach practice (10 min)",
    ],
    prepNotes: [
      "Update your LinkedIn headline and summary before the session",
      "List 5 companies you'd love to work at",
      "Draft a short 'about me' paragraph for outreach",
    ],
  },
  {
    id: 4,
    status: "past" as const,
    month: "APR",
    day: "4",
    dateLabel: "April 4, 2026",
    time: "10:00 AM",
    duration: "60 min",
    topic: "Goal Setting & Roadmap Planning",
    mentorName: "Sarah Chen",
    mentorRole: "Senior UX Designer",
    mentorCompany: "Figma",
    mentorPhoto: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20asian%20woman%20smiling%20warmly%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20confident%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor1&orientation=squarish",
    agenda: [
      "Intro & background sharing (10 min)",
      "Define 3-month career goal (15 min)",
      "Build a personalized learning roadmap (25 min)",
      "Set weekly accountability check-ins (10 min)",
    ],
    prepNotes: [
      "Bring your current resume",
      "Think about your dream role and company",
      "List your current skills and gaps",
    ],
  },
  {
    id: 5,
    status: "past" as const,
    month: "MAR",
    day: "28",
    dateLabel: "March 28, 2026",
    time: "6:30 PM",
    duration: "45 min",
    topic: "UX Research Methods Overview",
    mentorName: "Priya Sharma",
    mentorRole: "Product Manager",
    mentorCompany: "Notion",
    mentorPhoto: "https://readdy.ai/api/search-image?query=professional%20headshot%20of%20indian%20woman%20smiling%20warmly%2C%20soft%20studio%20lighting%2C%20clean%20white%20background%2C%20business%20casual%20attire%2C%20intelligent%20expression%2C%20high%20quality%20portrait%20photography&width=400&height=400&seq=mentor3&orientation=squarish",
    agenda: [
      "Overview of UX research methods (15 min)",
      "When to use qual vs quant research (15 min)",
      "Planning your first user interview (15 min)",
    ],
    prepNotes: [
      "Read the IDEO Design Thinking guide",
      "Prepare 5 user interview questions",
    ],
  },
];
